import { cn } from '@/lib/utils'
import { formatBuildingFloorLocation } from '@/utils/location'
import { useTranslation } from 'react-i18next'

type SelectedEquipmentCardProps = {
  name?: string | null
  serialNumber?: string | null
  serialNumbers?: string[] | null
  brand?: string | null
  model?: string | null
  categoryName?: string | null
  departmentName?: string | null
  buildingName?: string | null
  floorName?: string | null
  variant?: 'primary' | 'secondary'
}

export function SelectedEquipmentCard({
  name,
  serialNumber,
  serialNumbers,
  brand,
  model,
  categoryName,
  departmentName,
  buildingName,
  floorName,
  variant = 'primary',
}: SelectedEquipmentCardProps) {
  const { t } = useTranslation()
  const brandModel = [brand, model].filter(Boolean).join(' ')
  const serialNumbersText = serialNumbers?.join(', ')
  const location = [formatBuildingFloorLocation(t, buildingName, floorName)].filter(Boolean).join(' / ')

  if (!name && !serialNumber && !brandModel && !location) {
    return null
  }

  return (
    <div
      className={cn(
        'rounded-lg border p-3',
        variant === 'primary' ? 'border-primary/30 bg-primary/5' : 'border-border/30 bg-secondary/20',
      )}
    >
      <p className="text-xs text-muted-foreground">{t('common.selectedEquipmentLabel')}</p>
      {name && <p className="text-sm font-medium text-foreground">{name}</p>}
      {serialNumber && <p className="font-mono text-[10px] text-muted-foreground">{serialNumber}</p>}
      {serialNumbersText && <p className="font-mono text-[10px] text-muted-foreground">{serialNumbersText}</p>}
      {brandModel && <p className="text-[10px] text-muted-foreground">{brandModel}</p>}
      {categoryName && <p className="text-[10px] text-muted-foreground">{categoryName}</p>}
      {departmentName && (
        <p className="text-[10px] text-muted-foreground">
          {t('common.department')}: {departmentName}
        </p>
      )}
      {location && (
        <p className="text-[10px] text-muted-foreground">
          {t('common.location')}: {location}
        </p>
      )}
    </div>
  )
}
